import Vue from "vue";

import VerifiedPhone from "./VerifiedPhone.vue";

export function load() {
    const selector = "verified-phone";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(VerifiedPhone, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
